import { Center } from "@chakra-ui/react";

export const FollowOnlyIcon = () => {
  return (
    <Center
      w="20px"
      h="20px"
      borderTopRightRadius="4"
      borderBottomLeftRadius="4"
      bg="rgba(102, 102, 102, 0.6);"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_22659_17115)">
          <path
            d="M6.00016 9.16634C4.44016 9.16634 1.3335 9.94634 1.3335 11.4997V12.6663H10.6668V11.4997C10.6668 9.94634 7.56016 9.16634 6.00016 9.16634ZM2.8935 11.333C3.4535 10.9463 4.80683 10.4997 6.00016 10.4997C7.1935 10.4997 8.54683 10.9463 9.10683 11.333H2.8935ZM6.00016 7.99967C7.28683 7.99967 8.3335 6.95301 8.3335 5.66634C8.3335 4.37967 7.28683 3.33301 6.00016 3.33301C4.7135 3.33301 3.66683 4.37967 3.66683 5.66634C3.66683 6.95301 4.7135 7.99967 6.00016 7.99967ZM6.00016 4.66634C6.5535 4.66634 7.00016 5.11301 7.00016 5.66634C7.00016 6.21967 6.5535 6.66634 6.00016 6.66634C5.44683 6.66634 5.00016 6.21967 5.00016 5.66634C5.00016 5.11301 5.44683 4.66634 6.00016 4.66634ZM10.6935 9.20634C11.4668 9.76634 12.0002 10.513 12.0002 11.4997V12.6663H14.6668V11.4997C14.6668 10.153 12.3335 9.38634 10.6935 9.20634ZM10.0002 7.99967C11.2868 7.99967 12.3335 6.95301 12.3335 5.66634C12.3335 4.37967 11.2868 3.33301 10.0002 3.33301C9.64016 3.33301 9.30683 3.41967 9.00016 3.56634C9.42016 4.15967 9.66683 4.88634 9.66683 5.66634C9.66683 6.44634 9.42016 7.17301 9.00016 7.76634C9.30683 7.91301 9.64016 7.99967 10.0002 7.99967Z"
            fill="#FAFAFA"
          />
        </g>
        <defs>
          <clipPath id="clip0_22659_17115">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
